/* Deprecated compatibility adapter; active sections load guru-media-playback.js directly. */
(() => {
  if (window.GuruMediaPlayback?.scan) {
    window.GuruMediaPlayback.scan(document);
    return;
  }
  const current = document.currentScript?.src;
  if (!current) return;
  const script = document.createElement('script');
  script.src = current.replace(/header-hero-video\.js(?:\?.*)?$/, 'guru-media-playback.js');
  script.defer = true;
  document.head.append(script);
})();
